"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.StyledOption = exports.StyledMenuList = exports.StyledMenu = exports.StyledLabel = exports.StyledInput = exports.StyledGroupHead = exports.StyledGroup = exports.StyledCustomHead = exports.StyledCustomFoot = exports.StyledControlWrapper = exports.StyledChipRemove = exports.StyledChipLabel = exports.StyledChipContainer = exports.StyledChipAvatar = exports.StyledChip = exports.HelperText = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("..");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sizeHeightMap = {
  small: 36,
  medium: 44
};

var StyledOption = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  justify-content: flex-start;\n  align-content: flex-start;\n  color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  .eui-dd-opt {\n    &-label {\n      display: block !important;\n      ", "\n    }\n    &-email,\n    &-description {\n      ", "\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:last-child {\n    box-shadow: none;\n  }\n\n  .eui-dd-icon {\n    padding-right: 8px;\n  }\n  .eui-dd-desc {\n    color: ", ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    & > * {\n      ", "\n      color: inherit;\n      margin-right: 12px;\n      display: inline;\n\n      &:not(:last-child):after {\n        content: '\u2022';\n        position: relative;\n        left: 6px;\n      }\n    }\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('dark', '400')(props);
}, function (props) {
  return props.isDisabled && "\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n  ";
}, function (props) {
  return (0, _utils.getTypography)('body4')(props);
}, function (props) {
  return (0, _utils.getTypography)('body4')(props);
}, function (props) {
  return (0, _utils.getPalette)('primary', '100')(props);
}, function (props) {
  return (0, _utils.getPalette)('dark', '400')(props);
}, function (props) {
  return (0, _utils.getTypography)('body4')(props);
});

exports.StyledOption = StyledOption;

var StyledControlWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  & > .eui-dd-control {\n    box-shadow: none;\n    min-height: ", "px;\n    height: ", "px;\n    background-color: ", ";\n    padding: '10px 12px';\n    border-color: ", ";\n    ", "\n    border-radius: ", ";\n    overflow: hidden;\n    &:hover {\n      border-color: ", ";\n      }\n    }\n  }\n  ", "\n  ", "\n"])), function (props) {
  return sizeHeightMap[props.size];
}, function (props) {
  return sizeHeightMap[props.size];
}, function (props) {
  return props.error ? (0, _utils.getPalette)('red', '100') : props.isDisabled ? (0, _utils.getPalette)('dark', '100')(props) : (0, _utils.getPalette)('light', '100');
}, function (props) {
  return props.error ? (0, _utils.getPalette)('red', '300')(props) : (0, _utils.getPalette)('light', '400')(props);
}, function (props) {
  return props.menuIsOpen && "\n      border-color: ".concat((0, _utils.getPalette)('primary', '300')(props), " !important;\n    ");
}, function (props) {
  return (0, _utils.getBorderRadius)('primary')(props);
}, function (props) {
  return props.error ? (0, _utils.getPalette)('red', '300')(props) : (0, _utils.getPalette)('primary', '300')(props);
}, function (props) {
  return props.menuIsOpen && "\n    label {\n      color: ".concat((0, _utils.getPalette)('primary', '300')(props), " !important;\n    }\n  ");
}, function (props) {
  return props.isDisabled && "\n    .eui-dd-control {\n      cursor: not-allowed;\n    }\n    .eui-dd-indicator {\n      display: none;\n    }\n  ";
});

exports.StyledControlWrapper = StyledControlWrapper;

var StyledMenu = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  & > div {\n    box-shadow: ", ";\n    margin-top: 0px;\n    border-radius: ", ";\n    border: 1px solid ", ";\n  }\n"])), function (props) {
  return (0, _utils.getShadow)('aroundLow')(props);
}, function (props) {
  return (0, _utils.getBorderRadius)('primary')(props);
}, function (props) {
  return (0, _utils.getPalette)('light', '300')(props);
});

exports.StyledMenu = StyledMenu;

var StyledMenuList = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  & > div {\n    padding: 0px;\n    max-height: 160px;\n  }\n"])));

exports.StyledMenuList = StyledMenuList;

var StyledGroup = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])([""])));

exports.StyledGroup = StyledGroup;

var StyledGroupHead = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  background: ", ";\n  color: ", ";\n  padding: 0px 8px;\n  margin: 0px -8px;\n  position: relative;\n  ", "\n  &::after {\n    display: block;\n    height: 0.5px;\n    background: ", ";\n    content: '';\n    position: absolute;\n    bottom: 0px;\n    left: 8px;\n    right: 8px;\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('background', 'c01')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c01')(props);
}, function (props) {
  return props.isMulti && "\n    background: transparent;\n  ";
}, function (props) {
  return (0, _utils.getPalette)('text', 'c00')(props);
});

exports.StyledGroupHead = StyledGroupHead;

var StyledChip = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 3px 0px;\n"])));

exports.StyledChip = StyledChip;
var StyledLabel = (0, _styledComponents["default"])(_.Label)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n"])), function (props) {
  return props.menuIsOpen && "\n    color: ".concat((0, _utils.getPalette)('primary', 'c03')(props), "\n  ");
}, function (props) {
  return props.error && "color: ".concat((0, _utils.getPalette)('error', 'c03')(props));
});
exports.StyledLabel = StyledLabel;

var HelperText = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  color: ", ";\n  margin-top: 4px;\n"])), function (props) {
  return (0, _utils.getTypography)('helperText')(props);
}, function (props) {
  return props.error ? (0, _utils.getPalette)('red', '500')(props) : (0, _utils.getPalette)('dark', '400')(props);
});

exports.HelperText = HelperText;

var StyledInput = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  & > div {\n    margin: 0px;\n  }\n"])));

exports.StyledInput = StyledInput;
var styles = {
  container: function container(base) {
    return _objectSpread({}, base);
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread({}, base);
  },
  singleValue: function singleValue(base, props) {
    return _objectSpread(_objectSpread(_objectSpread({}, base), {}, {
      transform: 'translateY(-47%)'
    }, (0, _utils.getUniversalTypography)('body', 'regular', 'S')(props)), {}, {
      color: (0, _utils.getPalette)('grey', '900')(props),
      margin: '0px'
    });
  },
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      display: 'flex',
      alignItems: 'center'
    });
  },
  placeholder: function placeholder(base, props) {
    return _objectSpread(_objectSpread(_objectSpread({}, base), (0, _utils.getUniversalTypography)('body', 'regular', 'S')(props)), {}, {
      color: (0, _utils.getPalette)('grey', '600')(props),
      margin: '0px'
    });
  },
  group: function group(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: '0px'
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      maxMenuHeight: 310
    });
  }
};
exports.styles = styles;

var StyledCustomHead = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 8px 4px;\n  ", "\n  background-color: ", ";\n  color: ", ";\n"])), function (props) {
  return (0, _utils.getTypography)('captionText')(props);
}, function (props) {
  return (0, _utils.getPalette)('common', 'white')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c02')(props);
});

exports.StyledCustomHead = StyledCustomHead;

var StyledCustomFoot = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 8px 4px;\n  ", "\n  background-color: ", ";\n  color: ", ";\n"])), function (props) {
  return (0, _utils.getTypography)('captionText')(props);
}, function (props) {
  return (0, _utils.getPalette)('common', 'white')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c02')(props);
});

exports.StyledCustomFoot = StyledCustomFoot;

var StyledChipContainer = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  & > div {\n    background-color: ", ";\n    height: 36px;\n    border-radius: 40px;\n    align-items: center;\n    padding: 1px;\n  }\n  .mv-close {\n    display: inline-flex;\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('background', 'c02')(props);
});

exports.StyledChipContainer = StyledChipContainer;

var StyledChipLabel = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-left: 10px;\n  & > div {\n    color: ", ";\n  }\n  &.avatar {\n    padding-left: 0px;\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('primary', 'c03')(props);
});

exports.StyledChipLabel = StyledChipLabel;

var StyledChipRemove = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-right: 6px;\n  cursor: pointer;\n  & > div {\n    padding: 5px;\n    &:hover {\n      background: transparent;\n    }\n  }\n"])));

exports.StyledChipRemove = StyledChipRemove;

var StyledChipAvatar = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2["default"])([""])));

exports.StyledChipAvatar = StyledChipAvatar;